module.exports = __webpack_public_path__ + "static/media/banner-image-tgh.840fd591.png";